export default function ListItemLoading() {
  return <div className="h-[80px] min-h-[80px] w-full rounded bg-[#E7E7E7]"></div>;
}
